import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumStockMovementReferenceSource implements BaseEnumType {
  private static allValues: EnumStockMovementReferenceSource[] = []; // make sure this is top-most
  
  public static none = new EnumStockMovementReferenceSource(0, "None", "enum_stock_movement_reference_source_none");
  public static order = new EnumStockMovementReferenceSource(1, "Order", "enum_stock_movement_reference_source_order");
  public static credit = new EnumStockMovementReferenceSource(2, "Credit", "enum_stock_movement_reference_source_credit");
  public static transferFrom = new EnumStockMovementReferenceSource(3, "TransferFrom", "enum_stock_movement_reference_source_transfer_from");
  public static transferTo = new EnumStockMovementReferenceSource(4, "TransferTo", "enum_stock_movement_reference_source_transfer_to");
  public static assemblyInput = new EnumStockMovementReferenceSource(5, "AssemblyInput", "enum_stock_movement_reference_source_assembly_input");
  public static assemblyOutput = new EnumStockMovementReferenceSource(6, "AssemblyOutput", "enum_stock_movement_reference_source_assembly_output");
  public static purchaseOrder = new EnumStockMovementReferenceSource(7, "PurchaseOrder", "enum_stock_movement_reference_source_purchase_order");
  public static processInput = new EnumStockMovementReferenceSource(8, "ProcessInput", "enum_stock_movement_reference_source_process_input");
  public static processOutput = new EnumStockMovementReferenceSource(9, "ProcessOutput", "enum_stock_movement_reference_source_process_output");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStockMovementReferenceSource.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumStockMovementReferenceSource.none; }
  public isOrder() { return this === EnumStockMovementReferenceSource.order; }
  public isCredit() { return this === EnumStockMovementReferenceSource.credit; }
  public isTransferFrom() { return this === EnumStockMovementReferenceSource.transferFrom; }
  public isTransferTo() { return this === EnumStockMovementReferenceSource.transferTo; }
  public isAssemblyInput() { return this === EnumStockMovementReferenceSource.assemblyInput; }
  public isAssemblyOutput() { return this === EnumStockMovementReferenceSource.assemblyOutput; }
  public isPurchaseOrder() { return this === EnumStockMovementReferenceSource.purchaseOrder; }
  public isProcessInput() { return this === EnumStockMovementReferenceSource.processInput; }
  public isProcessOutput() { return this === EnumStockMovementReferenceSource.processOutput; }

  public static getValues(): readonly EnumStockMovementReferenceSource[] {
    return EnumStockMovementReferenceSource.allValues;
  }

  public static getValuesExcept0(): readonly EnumStockMovementReferenceSource[] {
    return EnumStockMovementReferenceSource.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStockMovementReferenceSource {
    const found = EnumStockMovementReferenceSource.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStockMovementReferenceSource - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStockMovementReferenceSource): EnumStockMovementReferenceSource {
    const found = name ? EnumStockMovementReferenceSource.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStockMovementReferenceSource - Value not found: ${ name }`);
    }

    return found;
  }
}